export enum GradeType {
  Custom = 'custom',
  Regular = 'regular',
}

interface ExtraSpread {
  value: number; // показываем > 0, если 0, то не показываем блочок с подарками
  endDate: number; // в секундах
}

export type GradeMonth = 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12;

export interface Grade {
  thisMonthCommissionTarget: number; // это таргет, сколько надо иметь, если isMax=true, или заработать, чтобы сохранить текущий грейд (isMax=true)
  targetPayout: number; // это сколько должно быть комиссии за 3 месяца, чтобы сохранить текущий грейд, если isMax=true, или, чтобы достичь следующий грейд (нужно только когда isMax=true)
}

export interface NextGrade extends Grade {
  experienceBonus: number // исчисляется не в USD, не нужно выводить с moneyPipe, но нужно делить на 100 тк прибавляется к payout как центы
}

export interface CalculatedGrade extends Grade {
  id: number;
  spread: number;
  isMax: boolean;
}

export interface GradesDto {
  month: GradeMonth;
  type: GradeType; // в будущем это нужно для отображения vip, fraud и тд
  thisMonthCommission: number; //на текущий момент, сколько комиссии, меняется постоянно
  currentPayout: number; // какая сейчас средняя комиссия за 3 месяца. Если активность меньше 3 месяцев - считает комиссию только за активное время. Включает надбавку за опыт
  averageCommission: number; // какая сейчас средняя комиссия за 3 месяца. Если активность меньше 3 месяцев - считает комиссию только за активное время. Не включает надбавку за опыт
  lastMonthCommission: number; // для статы: month - 1
  twoMonthAgoCommission: number; // для статы: month - 2
  calculatedGrade: CalculatedGrade;
  nextGrade: NextGrade;
  extraSpread: ExtraSpread;
}

interface GradeConditions {
  from: number;
  to: number;
  spread: number;
  grade: number;
  translateKey: string;
}

export type GradeSet = GradeConditions[];